(() => {
  const closeDelay = 320;

  function initializeSort(form) {
    const details = form.querySelector('[data-svasti-sort]');
    const summary = details?.querySelector('.svasti-sort__button');
    const backdrop = form.querySelector('[data-sort-backdrop]');
    const hiddenInput = form.querySelector('[data-sort-hidden]');
    const valueLabel = form.querySelector('.svasti-sort__value');
    const options = [...form.querySelectorAll('[data-sort-value]')];
    let closeTimer;

    if (!details || !summary || form.dataset.sortReady === 'true') return;
    form.dataset.sortReady = 'true';

    function openSort() {
      clearTimeout(closeTimer);

      document.querySelectorAll('.svasti-sort.is-open').forEach((openForm) => {
        if (openForm !== form) openForm.dispatchEvent(new CustomEvent('svasti-sort:close'));
      });

      details.classList.remove('is-closing');
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      form.classList.add('is-open');
      document.body.classList.add('svasti-sort-open');

      requestAnimationFrame(() => {
        options.find((option) => option.classList.contains('is-active'))?.focus({ preventScroll: true });
      });
    }

    function closeSort({ restoreFocus = true } = {}) {
      if (!details.hasAttribute('open')) return;

      clearTimeout(closeTimer);
      details.classList.add('is-closing');
      summary.setAttribute('aria-expanded', 'false');

      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        details.classList.remove('is-closing');
        form.classList.remove('is-open');

        if (!document.querySelector('.svasti-sort.is-open')) {
          document.body.classList.remove('svasti-sort-open');
        }

        if (restoreFocus) summary.focus({ preventScroll: true });
      }, closeDelay);
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.hasAttribute('open') && !details.classList.contains('is-closing')) {
        closeSort();
      } else {
        openSort();
      }
    });

    backdrop?.addEventListener('click', () => closeSort());
    form.addEventListener('svasti-sort:close', () => closeSort({ restoreFocus: false }));

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.sortValue || '';
        if (!hiddenInput) return;

        hiddenInput.value = value;
        options.forEach((item) => {
          const active = item === option;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-checked', active.toString());
        });

        if (valueLabel) {
          valueLabel.textContent = option.querySelector('.svasti-sort__name')?.textContent.trim() || 'Selected';
        }

        closeSort({ restoreFocus: false });
        window.setTimeout(() => form.requestSubmit(), closeDelay + 20);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!details.hasAttribute('open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeSort();
      }
    });
  }

  document.querySelectorAll('.svasti-sort').forEach(initializeSort);

  window.addEventListener('pagehide', () => {
    document.body.classList.remove('svasti-sort-open');
  });
})();
